import { useTranslation } from "react-i18next";
import CustomSelect from "../../../Forms/Element/CustomSelect";

const PeriodicitySelect = (props) => {

    const { t } = useTranslation();
    const options = [
        { value: "MONTHLY", label: t('monthly') },
        { value: "BIMONTHLY", label: t('bimonthly') },
        { value: "QUARTERLY", label: t('quarterly') },
        { value: "SEMI_ANNUAL", label: t('semi_annual') },
        { value: "YEARLY", label: t('yearly') },
    ];

    return (
        <CustomSelect
            placeholder={t('select')}
            options={options}
            {...props}
        />
    );
}

export default PeriodicitySelect;